symbolAnimator = {};
symbolAnimator.animationPool = [
  {
    poolName: "Empty",
    number: 0,
    pool: [],
    anims: [],
    backings: [],
  },
];
symbolAnimator.currentAnimations = [];
symbolAnimator.gameReels = undefined;
symbolAnimator.slotContainer = undefined;
symbolAnimator.ready = false;
symbolAnimator.finishedCallback = undefined;
symbolAnimator.completeCallback = undefined;

symbolAnimator.symbolIDMap = [
  { id: 0, name: "Ten", anim: 0, scale: 1 }
];

symbolAnimator.initialise = function () {
  symbolAnimator.gameReels = gameData.reels;
  symbolAnimator.slotContainer = resourceManager.get("mainReelsContainer:slotContainer:reelContainer");
  symbolAnimator.backingContainer = resourceManager.get("mainReelsContainer:slotContainer:reelContainer:backingContainer");

  symbolAnimator.createPoolAnim("Ten", 0, ["10_Win"]);
  symbolAnimator.ready = true;
};

symbolAnimator.createPoolAnim = function (name, index, animNames = undefined) {
  let spineAnim = undefined;
  let backings = [];
  let symbolId;
  for (let index = 0; index < symbolAnimator.symbolIDMap.length; index++) {
    if (symbolAnimator.symbolIDMap[index].name === name) {
      symbolId = symbolAnimator.symbolIDMap[index].id;
      break;
    }
  }

  let animNamesCheck = animNames;

  let found = false;

  //Search for pool name
  for (let i = 0; i < symbolAnimator.animationPool.length; i++) {
    let poolType = symbolAnimator.animationPool[i];

    //If pool name exists add a new anim there
    if (poolType.poolName === name) {
      found = true;

      animNamesCheck = poolType.anims;

      spineAnim = resourceManager.createObject("spine", "Scale" + name + index, symbolAnimator.slotContainer, {
        name: name,
        defaultAnimation: animNamesCheck[0],
        scaleX: 1,
        scaleY: 1,
      });

      //create backings

      for (let i = 0; i < poolType.backingPool.fileNames.length; i++) {
        const backingFileName = poolType.backingPool.fileNames[i];

        const backing = resourceManager.createObject(
          "sprite",
          name + index + "Backing" + i,
          symbolAnimator.backingContainer,
          {
            fileName: backingFileName,
            scale: 1,
            anchor: 0.5,
          }
        );
        backing.visible = false;
        backings.push(backing);
      }

      poolType.pool.push(spineAnim);
      poolType.number++;
      poolType.backingPool.pool.push([backings]);

      break;
    }
  }

  if (!found) {
    //Otherwise create a new anim pool with this name
    spineAnim = resourceManager.createObject("spine", "Scale" + name + index, symbolAnimator.slotContainer, {
      name: name,
      defaultAnimation: animNamesCheck[0],
      scaleX: 1,
      scaleY: 1,
    });

    //create backings
    const fileNames = [];

    for (let i = 0; i < animNamesCheck.length; i++) {
      const symbolIdOffset = i * 20;
      const backingFileName = symbolAnimator.getSymbolBackingFileName(symbolId + symbolIdOffset);

      const backing = resourceManager.createObject(
        "sprite",
        name + index + "Backing" + i,
        symbolAnimator.backingContainer,
        {
          fileName: backingFileName,
          scale: 1,
          anchor: 0.5,
        }
      );
      backing.visible = false;
      backings.push(backing);
      fileNames.push(backingFileName);
    }

    symbolAnimator.animationPool.push({
      poolName: name,
      number: 0,
      pool: [spineAnim],
      anims: animNamesCheck,
      backingPool: {
        pool: [backings],
        fileNames: fileNames,
      },
    });
  }

  spineAnim.visible = false;

  return { spine: spineAnim, backings: backings };
};

symbolAnimator.findSpineAndBacking = function (symbolId) {
  let spine = undefined;
  let location = 0;
  symbolId = symbolId % 20;
  let spineAnimName = symbolAnimator.symbolIDMap[symbolId].name;

  if (spineAnimName === "Empty") {
    return undefined;
  }

  for (let i = 0; i < symbolAnimator.animationPool.length; i++) {
    let poolType = symbolAnimator.animationPool[i];

    if (poolType.poolName === spineAnimName) {
      number = poolType.number;
      location = i;

      if (poolType.pool.length > 0) {
        spine = poolType.pool[0];
        backings = poolType.backingPool.pool[0];

        poolType.pool.splice(0, 1);
        poolType.backingPool.pool.splice(0, 1);
        return { spine: spine, backings: backings };
      }
    }
  }

  spineAndbackings = symbolAnimator.createPoolAnim(spineAnimName, number + 1);
  symbolAnimator.animationPool[location].pool.pop();
  symbolAnimator.animationPool[location].backingPool.pool.pop();

  return spineAndbackings;
};

symbolAnimator.animate = function (symbols, callback, callBackDelay) {
  symbolAnimator.finishedCallback = callback;
  symbolAnimator.callBackDelay = callBackDelay;

  for (let i = 0; i < symbols.length; i++) {
    let symbol = symbols[i];
    let symId = symbol.symbolId;
    if (symId !== 18 && symId !== 38 && symId !== 58 && symId !== 78 && symId !== 98) {
      symbolAnimator.animateSymbol(symbol);
    }
  }
};

symbolAnimator.animateSymbol = function (symbol) {
  const id = symbol.symbolId % 20;
  let sizeOffset = Math.floor(symbol.symbolId / 20);
  const reel = symbol.cell.reel;
  const row = symbol.cell.row;

  let symbolMapIndex = undefined;

  for (let index = 0; index < symbolAnimator.symbolIDMap.length; index++) {
    if (symbolAnimator.symbolIDMap[index].id === id) {
      symbolMapIndex = index;
      break;
    }
  }

  let spineAndBacking = symbolAnimator.findSpineAndBacking(symbolMapIndex);

  if (spineAndBacking === undefined) {
    return;
  }

  let animNum =
    symbolAnimator.symbolIDMap[symbolMapIndex].anim === 0 && sizeOffset > 0
      ? 1 * sizeOffset
      : symbolAnimator.symbolIDMap[symbolMapIndex].anim * sizeOffset;
  let animNames = symbolAnimator.findAnimNames(symbolMapIndex);

  let symbolToHide = resourceManager.get("mainReelsContainer:slotContainer:reelContainer:reel" + reel + ":symbol" + row);
  symbolToHide.visible = false;
  const spine = spineAndBacking.spine;
  const backing = spineAndBacking.backings[animNum];

  backing.visible = true;

  let animationObject = {
    anim: spine,
    reel: reel,
    row: row,
    backing: backing,
    symbolToHide: symbolToHide,
  };

  symbolAnimator.currentAnimations.push(animationObject);

  symbolAnimator.positionAnim(animationObject);

  spine.visible = true;
  spine.anim = animNames[animNum];
  spine.play(animNames[animNum], false, 0, () => {
    symbolAnimator.animationFinished(animationObject);
    symbolAnimator.returnToPool(symbolAnimator.symbolIDMap[symbolMapIndex].name, spine, spineAndBacking.backings);
    symbolToHide.visible = true;
  });
};

symbolAnimator.animationFinished = function (animationObject) {
  if (animationObject !== undefined) {
    animationObject.anim.visible = false;
    animationObject.backing.visible = false;
    animationObject.symbolToHide.visible = true;
    symbolAnimator.currentAnimations.splice(symbolAnimator.currentAnimations.indexOf(animationObject), 1);
  }

  if (symbolAnimator.currentAnimations.length === 0) {
    if (symbolAnimator.finishedCallback) {
      if (symbolAnimator.callBackDelay !== undefined) {
        symbolAnimator.completeCallback = symbolAnimator.finishedCallback;
        timerManager.addTimeout(symbolAnimator.callBackDelay, function () {
          if (symbolAnimator.completeCallback) {
            symbolAnimator.completeCallback();
          }
        });
      } else {
        symbolAnimator.finishedCallback();
      }
    }
  }
};

symbolAnimator.findAnimNames = function (symbolId) {
  let spineAnimName = symbolAnimator.symbolIDMap[symbolId].name;

  for (let i = 0; i < symbolAnimator.animationPool.length; i++) {
    let poolType = symbolAnimator.animationPool[i];

    if (poolType.poolName === spineAnimName) {
      animNames = poolType.anims;
      return animNames;
    }
  }

  return undefined;
};

symbolAnimator.returnToPool = function (name, spine, backings) {
  for (let index = 0; index < backings.length; index++) {
    const backing = backings[index];
    backing.visible = false;
  }

  for (let i = 0; i < symbolAnimator.animationPool.length; i++) {
    let poolType = symbolAnimator.animationPool[i];

    if (poolType.poolName === name) {
      poolType.pool.push(spine);
      poolType.backingPool.pool.push(backings);
    }
  }
};

symbolAnimator.positionAnim = function (animationObject, symbol = undefined) {
  const anim = animationObject.anim;
  const reel = animationObject.reel;
  const row = animationObject.row;

  if (symbol === undefined) {
    symbol = resourceManager.get("mainReelsContainer:slotContainer:reelContainer:reel" + reel + ":symbol" + row);
  }

  const symbolPos = helper.getCenterSymbolsPos(reel, row);

  const x = symbolPos.x;
  const y = symbolPos.y;

  anim.position.set(x, y);
  animationObject.backing.position.set(x, y);
};

symbolAnimator.getSymbolBackingFileName = function (symbolId) {
  let sizeOffset = Math.floor(symbolId / 20);
  const id = symbolId % 20;
  let symbolType = "Default";

  let fileName;
  switch (sizeOffset) {
    case 0:
      switch (symbolType) {
        case "Default":
          fileName = "Symbols/BACK_BORDER_x3.png";
          break;
      }
      break;
  }

  return fileName;
};

symbolAnimator.skip = function () {
  symbolAnimator.currentAnimations.forEach((animation) => {
    symbolAnimator.returnToPool(animation.anim.name, animation.anim, animation.backing);
    animation.anim.visible = false;
    animation.backing.visible = false;
    animation.symbolToHide.visible = true;
  });

  symbolAnimator.currentAnimations = [];
  symbolAnimator.finishedCallback = undefined;
  symbolAnimator.completeCallback = undefined;
};

symbolAnimator.getSpineAnimation = function (symbolId) {
  let sizeOffset = Math.floor(symbolId / 20);
  const id = symbolId % 20;
  switch (sizeOffset) {
    case 0:
      switch (id) {
        case 0:
          return "10_Win";
      }
      break;
  }

  return "Failed to find spine animation.. Somehow????";
};

symbolAnimator.getSpineName = function (symbolId) {
  const id = symbolId % 20;
  switch (id) {
    case 0:
      return "Ten";
  }
};

symbolAnimator.orientationChange = function () {
  if (symbolAnimator.ready) {
    timerManager.addTimer(5, () => {
      symbolAnimator.currentAnimations.forEach((animationObject) => {
        symbolAnimator.positionAnim(animationObject);
      });
    });
  }
};

Reflex.registerEventHandler("layoutChange", symbolAnimator.orientationChange);
Reflex.registerEventHandler("orientationChange", symbolAnimator.orientationChange);
